import { ButtonBase, makeStyles } from '@material-ui/core';
import DoneIcon from '@material-ui/icons/Done';
import FileCopyIcon from '@material-ui/icons/FileCopy';

const useStyles = makeStyles(theme => ({
  copyButton: {
    borderRadius: '50%',
    boxShadow: theme.shadows[6],
    backgroundColor: theme.palette.primary.main,
  },
  copyIcon: {
    padding: '0 3px',
    color: theme.palette.getContrastText(theme.palette.primary.main),
  },
}));

type Props = {
  copied: boolean;
  onCopy: () => void;
};

export default function CopyButton({ copied, onCopy }: Props) {
  const classes = useStyles();
  const Icon = copied ? DoneIcon : FileCopyIcon;

  return (
    <ButtonBase
      title="Copiar texto"
      aria-label="copy text"
      onClick={onCopy}
      className={classes.copyButton}
    >
      <Icon fontSize="small" className={classes.copyIcon} />
    </ButtonBase>
  );
}
